// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  localUrl: "http://localhost:44383/api/v1/",
  baseUrl: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
  baseUrl2: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
  baseUrlV2: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
  baseUrlV4: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
  baseUrlCoreApi: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
  baseUrlNotify: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
